// components/AddNewClientModal.jsx
import React, { useState, useEffect } from 'react'
import ApiClient from '../../../api/client'
import { useProgramStore } from '../../../../store/useProgramStore'

const apiClient = new ApiClient()

const AddNewClientModal = ({ isOpen, onClose }) => {
  const { addProgram } = useProgramStore()
  // const [formData, setFormData] = useState({
  //   client_name: '',
  //   email: '',
  //   program_id: '',
  //   // add more fields as needed
  // })

  const [name, setName] = useState('')
  const [new_code, setNewCode] = useState('')
  const [image, setImage] = useState(null)
  const [programId, setProgramId] = useState('')
  const [status, setStatus] = useState('')
  const [program, setProgram] = useState([])
  const [statusOption, setStatusOption] = useState([])

  const statuses = [
    { id: 1, name: 'RBI' },
    { id: 2, name: 'CBI' },
  ]

  // const handleChange = (e) => {
  //   const { name, value } = e.target
  //   setFormData((prev) => ({
  //     ...prev,
  //     [name]: value,
  //   }))
  // }

  useEffect(() => {
    const fetchProgram = async () => {
      const { data, error } = await apiClient.fetchAllPrograms()
      if (data) {
        setProgram(data)
      }
    }
    fetchProgram()

    setStatusOption(statuses)
  }, [])

  const handleSubmit = async (e) => {
    e.preventDefault()
    await addProgram(name, image, new_code)
    onClose() // close modal after success
    
  }

  if (!isOpen) return null

  return (
    <div className="fixed inset-0 z-50 bg-black bg-opacity-30 flex justify-center items-center">
      <div className="bg-white w-[80%] max-w-md p-6 rounded shadow">
        <h2 className="text-xl font-semibold mb-4">Add New Program</h2>

        <form onSubmit={handleSubmit} className="space-y-4" autoComplete="off">
          <input
            type="text"
            name="client_name"
            placeholder="Program Name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            className="w-full p-2 border border-gray-300 rounded"
            required
          />
          {/* <select
            name="status"
            id="status"
            value={status}
            className="w-full border mb-4 p-2 rounded"
            onChange={(e) => setStatus(e.target.value)}
            placeholder="Status"
          >
            <option value="">Select program category</option>
            {statuses
              ? statusOption.map((e) => (
                  <option key={e.id} value={e.name}>
                    {e.name}
                  </option>
                ))
              : alert(<span className="text-red-700">Select an option!</span>)}
          </select> */}
          <input
            type="file"
            name="image"
            placeholder="image"
            accept="image/*"
            onChange={(e) => setImage(e.target.files[0])}
            className="w-full p-2 border border-gray-300 rounded"
          />
          <input
            type="text"
            name="new_code"
            placeholder="Program new code"
            value={new_code}
            onChange={(e) => setNewCode(e.target.value)}
            className="w-full p-2 border border-gray-300 rounded"
          />
          {/* Add dropdown if you want to show program names later */}
          <div className="flex justify-end space-x-2">
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2 bg-gray-300 rounded hover:bg-gray-400"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
            >
              Add Program
            </button>
          </div>
        </form>
      </div>
    </div>
  )
}

export default AddNewClientModal
